const accordionBtns = document.querySelectorAll(".accordion-btn"),
  accordionPanels = document.querySelectorAll(".accordion-panel");

export default function init() {
  accordionBtns.forEach((btn, index) => {
    document.addEventListener("click", (btnClick) => {
      if (btnClick.target === btn) {
        let panel = accordionPanels[index];
        btn.classList.toggle("open-accordion");
        panel.classList.toggle("open-accordion");
      }
    });
  });

}
